// extracted by mini-css-extract-plugin
export default {"container":"buy-now-module__container___o3Mpo","button":"buy-now-module__button___GEVF3","button--spacing":"buy-now-module__button--spacing___miSUm"};